// extracted by mini-css-extract-plugin
export default {"Btn":"Replay_Btn__AEja4"};